import { render } from "./PayrollperEmployee.vue?vue&type=template&id=4e5cb7f9"
import script from "./PayrollperEmployee.vue?vue&type=script&lang=js"
export * from "./PayrollperEmployee.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\abbas\\Desktop\\kswc\\kswc_dashboard-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__